import Vue from 'vue';

const config = {
   serverHost: process.env.VUE_APP_API_URL,
   appName: 'Atena2'
};

Vue.prototype.$appConfig = config;

export default config;
